define('../src/sublayouts/m2-hero-image/m2-hero-image',['jquery', 'lib/utils'], function($, utils) {

    'use strict';

    var M2_HERO = function($component) {

        this.$component = $component;

        return this;
    };

    /**
     * Initialize component
     */

    M2_HERO.prototype.init = function() {
        var _this = this;

        if (utils.breakpoint() != 's') {
            _this.center();
        } else {
            _this.$component.attr('style', '');
        }

        $(window).off('resize.m2').on('resize.m2', function() {
            setTimeout(function() {
                if (utils.breakpoint() != 's') {
                    _this.center();
                } else {
                    _this.$component.attr('style', '');
                    _this.$component.find('.m2-hero-image-tag').attr('style', '');
                };
            }, 100);
        });

    };

    M2_HERO.prototype.center = function() {
        var _this = this,
            windowHeight = $(window).outerHeight(true),
            tag = this.$component.find('.m2-hero-image-tag'),
            tagHeight = tag.outerHeight(true);

        this.$component.css('height', windowHeight.toString() + 'px');

        if (((windowHeight - tagHeight) / 2) > 180) {
            tag.css('top', ((windowHeight - tagHeight) / 2).toString() + 'px');
        } else {
            tag.css('top', '180px');
        };


    };

    return M2_HERO;
});

